import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { ApiParamsType } from '@/features/shared/types/ApiParamsType';
import { OrgTypeEnum } from '@/types/common';

import { getOrganizations } from '../actions/getOrganizations';

type GetOrganizationsParams = ApiParamsType & {
  sourcedIds?: string[];
  orgTypes?: OrgTypeEnum[];
};

const getOrganizationsQueryKey = (params: GetOrganizationsParams) => [
  'organizations',
  params,
];

export const getOrganizationsQueryOptions = (params: GetOrganizationsParams) =>
  queryOptions({
    queryKey: getOrganizationsQueryKey(params),
    staleTime: 5 * 60 * 1000,
    placeholderData: keepPreviousData,
    queryFn: async () => {
      const response = await getOrganizations({
        data: params,
      });

      if (!response.success || response.error) {
        throw new Error(response.error || 'Failed to fetch organizations');
      }

      return response.data;
    },
  });

export const useGetOrganizations = (params: GetOrganizationsParams) =>
  useQuery(getOrganizationsQueryOptions(params));
